import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b88e1ec"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b88e1ec')) {
      api.createRecord('3b88e1ec', component.options)
    } else {
      api.reload('3b88e1ec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3b88e1ec", function () {
      api.rerender('3b88e1ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/ads/FontAwesomeAd/index.vue"
export default component.exports